import { Injectable } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SnackbarResultStyle} from '../components/models';
import {
  OperationResultSnackBarComponent
} from '../components/operation-result-snack-bar/operation-result-snack-bar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackBar: MatSnackBar) { }

  openSuccessSnackBar(message: string, duration: number = 3000): void {
    this.openSnackBar(message, SnackbarResultStyle.SUCCESS, duration);
  }

  openErrorSnackBar(message: string, duration: number = 3000): void {
    this.openSnackBar(message, SnackbarResultStyle.ERROR, duration);
  }

  private openSnackBar(message: string, panelClass: string, duration: number): void {
    this.snackBar.openFromComponent(OperationResultSnackBarComponent, {
      panelClass,
      duration,
      data: {
        message
      }
    });
  }


}
